import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getOrdenesCompra } from '../../helpers/api_helper';

const useObtenerOrdenesCompra = (refresh = 0) => {
    const [ordenesCompra, setOrdenesCompra] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchOrdenesCompra = async () => {
            if (!tenantId || !empresa) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getOrdenesCompra({
                    tenantId, empresa
                });
                setOrdenesCompra(response);
            } catch (err) {
                const errorMessage = `Failed to fetch ordenes compra: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setOrdenesCompra(null);
            } finally {
                setLoading(false);
            }
        };

        fetchOrdenesCompra();
    }, [tenantId, empresa, refresh]);

    return { ordenesCompra, loading, error };
};

export default useObtenerOrdenesCompra;